import { render, staticRenderFns } from "./ManagementCommission.vue?vue&type=template&id=6a6ff2e9&scoped=true&"
import script from "./ManagementCommission.vue?vue&type=script&lang=ts&"
export * from "./ManagementCommission.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementCommission.vue?vue&type=style&index=0&id=6a6ff2e9&prod&lang=css&"
import style1 from "./ManagementCommission.vue?vue&type=style&index=1&id=6a6ff2e9&prod&lang=scss&"
import style2 from "./ManagementCommission.vue?vue&type=style&index=2&id=6a6ff2e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6ff2e9",
  null
  
)

export default component.exports